module.exports = __webpack_public_path__ + "img/index_blue.2e689af5.svg";